export default {
  bloodType: {
    apositive: 'A+',
    anegative: 'A-',
    abpositive: 'AB+',
    abnegative: 'AB-',
    bpositive: 'B+',
    bnegative: 'B-',
    opositive: 'O+',
    onegative: 'O-',
    unknown: 'Unknown',
  },
}
